import { Box, TextField, InputAdornment, TableContainer, Table, TableBody, TableRow, TableCell, Checkbox, IconButton, Popover, MenuItem, Typography, Avatar, FormControl, InputLabel, Select, Grid, TableHead, Divider, LinearProgress, Button, Hidden } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useTranslation } from "react-i18next";
import { numberFormat, numberFormatWithK } from "../../../utils/nunberFormat";
import { DEFAULT_ROWS_PER_PAGE } from "../../../config-global";
import Pagination from '@mui/material/Pagination';
import { SELECT_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from "../../../constants/colors";
import ACTIVE_PRODUCT_STATISTIC from '../../../assets/images/active_product_static.svg';
import INACTIVE_PRODUCT_STATISTIC from '../../../assets/images/inactive_product_statistic.svg';
import ALL_PRODUCT_STATISTIC from '../../../assets/images/all_product_statistic.svg';
import PRODUCT_NEED_TO_APPROVE_STATISTIC from '../../../assets/images/product_need_to_approve.svg';
import InfoIcon from '@mui/icons-material/Info';
import { IMAGE_CUSTOMER } from "../../../lib/endpoints/customer";
import { OrderModel } from "../../../models/order";
import { calculateOrderProductUnitByCarts } from "../../../utils/calculateOrderProductUnitByCarts";
import OrderDetail from "../../order/Detail";
import useSalesReportController from "./controller";
import TabPanelComponent from "./components/tabPanel";
import { ShipmentMethodEnum } from "../../../enums/shipmentMethod";
import { PaymentMethodEnum } from "../../../enums/paymentMethod";
import ButtonExportCsv from "../../../components/ButtonExportCsv";
import { CSV_ORDER_HEADER } from "../csvHeaders/order";
import { OrderStatusEnum } from "../../../enums/orderStatus";
import ShipmentMethodChip from "../../../components/ShipmentMethodChip";
import { findOrderCreateTime } from "../../../utils/findOrderCreareTime";
import { OrderShipmentEnum } from "../../../enums/orderShipment";
import TabShowOrderComponent from "./components/tabShowOrder";
import ShipmentMethodRiderDetail from "../../../components/ShipmentMethodRider";



const SalesReportView = () => {
    const { t } = useTranslation("global");

    const controller = useSalesReportController();
    // const tableHeaders: string[] = [t("No."), t("Image"), t("Product name"), t("Barcode"), t("Branch"), ""];
    const tableHeaders: string[] = [t("order_page.No"), t("order_page.Customer name"), t("order_page.Order ID"), t("order_page.Order number"), t("order_page.Item unit"), t("order_page.Phone"), t("order_page.Shipment method"), t("order_page.Price"), t("order_page.Order time"), ""];
    const simplifiedHeaders: string[] = [t("order_page.No"), t("order_page.Order ID"), t("order_page.Order time"), ""];
    console.log(controller.rows);

    return <Box>

        <Box sx={{ display: controller.loading ? "none" : "block" }}>
            {
                !controller.selectedData
                    ?
                    <Box>
                        <Box mb={5} >

                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Typography variant="h5" fontWeight="bold" color={TEXT_TITLE_COLOR}>{t("drawer_component.Sales Report")}</Typography>
                                <TextField onKeyDown={(e: any) => {
                                    if (e.key === "Enter") {
                                        controller.handleGetDataByOrderId();
                                    }
                                }} inputRef={controller.searchRef} fullWidth sx={{ maxWidth: 250 }} placeholder={t("order_page.Search by Order ID") || ""} InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" onClick={controller.handleGetDataByOrderId}>
                                            <SearchIcon sx={{ cursor: 'pointer' }} />
                                        </InputAdornment>
                                    )
                                }} size="small" />
                                <TextField required inputRef={controller.startDateRef} type="date" fullWidth sx={{
                                    maxWidth: 150, "& .MuiOutlinedInput-root": {
                                        "& > fieldset": {
                                            border: "none"
                                        }
                                    }
                                }} size="small" label={t("order_page.Start date")} InputProps={{
                                    disableUnderline: true,
                                    style: {
                                        backgroundColor: SELECT_BACKGROUND_COLOR,
                                        borderRadius: '8px'
                                    }
                                }} InputLabelProps={{ shrink: true }} />
                                <TextField required inputRef={controller.endDateRef} type="date" fullWidth sx={{
                                    maxWidth: 150, "& .MuiOutlinedInput-root": {
                                        "& > fieldset": {
                                            border: "none"
                                        }
                                    }
                                }} size="small" label={t("order_page.End date")} InputProps={{
                                    disableUnderline: true,
                                    style: {
                                        backgroundColor: SELECT_BACKGROUND_COLOR,
                                        borderRadius: '8px'
                                    }
                                }} InputLabelProps={{ shrink: true }} />
                                <FormControl fullWidth sx={{ maxWidth: 148 }}>
                                    <InputLabel id="shipment-method-label-id">{t("order_page.Shipment method")}</InputLabel>
                                    <Select
                                        labelId="shipment-method-label-id"
                                        id="shipment-method-id"
                                        value={controller.shipmentMethod}
                                        label="Shipment method"
                                        size="small"
                                        onChange={(e) => controller.setShipmentMethod(e.target.value)}
                                        sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                                    // onChange={handleChange}
                                    >
                                        <MenuItem value={OrderShipmentEnum.All}>{t("All")}</MenuItem>
                                        <MenuItem value={OrderShipmentEnum.Delivery}>{t("Delivery")}</MenuItem>
                                        <MenuItem value={OrderShipmentEnum.PickUp}>{t("Pick Up")}</MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth sx={{ maxWidth: 148 }}>
                                    <InputLabel id="payment-method-label-id">{t("order_page.Payment method")}</InputLabel>
                                    <Select
                                        labelId="payment-method-label-id"
                                        id="payment-method-id"
                                        value={controller.paymentMethod}
                                        label="Payment method"
                                        size="small"
                                        onChange={(e) => controller.setPaymentMethod(e.target.value)}
                                        sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                                    // onChange={handleChange}
                                    >
                                        <MenuItem value="All">{t("All")}</MenuItem>
                                        <MenuItem value={PaymentMethodEnum.BCELONE}>{t("BCELONE")}</MenuItem>
                                        <MenuItem value={PaymentMethodEnum.CASH}>{t("CASH")}</MenuItem>
                                    </Select>
                                </FormControl>
                                {/* <FormControl fullWidth sx={{ maxWidth: 148 }}>
                                    <InputLabel id="status-label-id">Status</InputLabel>
                                    <Select
                                        labelId="status-label-id"
                                        id="status-id"
                                        value={controller.currentOrderStatus}
                                        label="Status"
                                        size="small"
                                        onChange={(e) => controller.setCurrentOrderStatus(e.target.value as OrderStatusEnum)}
                                        sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                                    >
                                        <MenuItem value={OrderStatusEnum.Delivered}>{t("report_page.Delivered")}</MenuItem>
                                        <MenuItem value={OrderStatusEnum.PARTIALLY}>{t("report_page.Partially completed")}</MenuItem>
                                        <MenuItem value={OrderStatusEnum.Failed}>{t("report_page.Returned")}</MenuItem>
                                        <MenuItem value={OrderStatusEnum.Return}>{t("report_page.Canceled")}</MenuItem>
                                    </Select>
                                </FormControl> */}
                                <Button onClick={controller.handleFilterData} variant="contained" color="secondary" sx={{ color: 'white', textTransform: 'none', width: 100 }} >{t("Filter")}</Button>
                            </Box>
                        </Box>
                        <Box mb={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ backgroundColor: '#C8FACD', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#005249" sx={{ mb: 1 }}>{t("All")}</Typography>
                                            <Typography color="#005249" fontWeight="bold" fontSize={32}>{numberFormatWithK(controller.dataReportStatistic.all)}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={ACTIVE_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ backgroundColor: '#C4EAFF', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#7A4100" sx={{ mb: 1 }}>{t("report_page.Delivered")}</Typography>
                                            <Typography color="#7A4100" fontWeight="bold" fontSize={32}>{numberFormat(controller.dataReportStatistic?.delivered)}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={ALL_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ backgroundColor: '#FFF5CC', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#7A4100" sx={{ mb: 1 }}>{t("report_page.Partially completed")}</Typography>
                                            <Typography color="#7A4100" fontWeight="bold" fontSize={32}>{numberFormat(controller.dataReportStatistic?.partiallyCompletedSale)}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={PRODUCT_NEED_TO_APPROVE_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ background: 'rgba(145, 158, 171, 0.32)', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#7A4100" sx={{ mb: 1 }}>{t("report_page.Returned")}</Typography>
                                            <Typography color="#7A4100" fontWeight="bold" fontSize={32}>{numberFormat(controller.dataReportStatistic?.returnSale)}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={INACTIVE_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ backgroundColor: '#FFB1BB', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#7A4100" sx={{ mb: 1 }}>{t("report_page.Cancelled")}</Typography>
                                            <Typography color="#7A4100" fontWeight="bold" fontSize={32}>{numberFormat(controller.dataReportStatistic?.failedSale)}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={INACTIVE_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>

                            </Grid>
                        </Box>
                        <Box sx={{ mt: 1, mb: 1, display: 'flex', justifyContent: 'end' }}>
                            <ButtonExportCsv loading={false} onClick={() => {
                                if (controller.buttonExportCsv.current) {
                                    controller.buttonExportCsv.current.link.click();
                                }
                            }} buttonRef={controller.buttonExportCsv} title={t("Export CSV")} data={controller.findDataExportCsv()} filename="order_report.csv" headers={CSV_ORDER_HEADER} />
                        </Box>
                        <Box mb={2}>
                            <TabShowOrderComponent value={controller.showInMoney} onChange={(newValue: string) => controller.setShowInMoney(newValue)} />
                        </Box>
                        <Box mb={2}>
                            <TabPanelComponent value={controller.currentOrderStatus} onChange={controller.handleCurrentOrderStatusChange} />
                        </Box>
                        {
                            !controller.loadingGetData
                                ?
                                <Box sx={{ mt: 2 }}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead sx={{ background: '#F4F6F8' }}>
                                                <Hidden smDown>
                                                    <TableRow>
                                                        {tableHeaders?.map((item, index) => (
                                                            <TableCell key={index} sx={{ borderBottom: 'none' }}>{item}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                </Hidden>
                                                <Hidden smUp>
                                                    <TableRow>
                                                        {simplifiedHeaders.map((item, index) => (
                                                            <TableCell key={index} sx={{ borderBottom: 'none' }}>{item}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                </Hidden>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    controller.rows?.map((row: OrderModel, index: number) => {
                                                        const customerImage: string = IMAGE_CUSTOMER + row?.customer?.profile?.image?.url;
                                                        return (
                                                            <>
                                                                <Hidden smDown>
                                                                    <TableRow hover key={row?.id} tabIndex={-1}>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat((index + 1) + (DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1)))}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                                                <Avatar
                                                                                    src={customerImage}
                                                                                    alt='Customer'
                                                                                    sx={{ cursor: 'pointer', objectFit: 'contain', borderRadius: 12, width: 50, height: 50 }}
                                                                                    onClick={() => window.open(customerImage)}
                                                                                />
                                                                                <Typography>{row?.customer?.profile?.fullName}</Typography>
                                                                            </Box>

                                                                        </TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderNo}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderNumber}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{calculateOrderProductUnitByCarts(row?.carts)}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{controller.currentOrderStatus === OrderStatusEnum.Rider_Getting_Order ? row?.rider?.profile?.fullName : row?.orderMethod === ShipmentMethodEnum.PICK_UP ? row?.customer?.phone : row?.customer?.phone}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                            {
                                                                                row.riderAssist === true ? <ShipmentMethodRiderDetail value={row.riderDetail} /> : <ShipmentMethodChip value={row?.orderMethod as ShipmentMethodEnum} />
                                                                            }
                                                                        </TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat(row?.totoalWithDeliveryFee)} {t("Kip")}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{findOrderCreateTime(row)}</TableCell>
                                                                        <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                                                            <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, row?.id)}>
                                                                                <MoreHorizIcon />
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </Hidden>
                                                                <Hidden smUp>
                                                                    <TableRow hover key={row?.id} tabIndex={-1}>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat((index + 1) + (DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1)))}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderNo}</TableCell>
                                                                        <TableCell align="left" sx={{ borderBottom: 'none' }}>{findOrderCreateTime(row)}</TableCell>
                                                                        <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                                                            <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, row?.id)}>
                                                                                <MoreHorizIcon />
                                                                            </IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </Hidden>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Divider sx={{ mt: 1, mb: 1 }} />
                                    {
                                        controller.loadingFetchDataMore
                                        &&
                                        <Box mb={2} mt={2}>
                                            <LinearProgress />
                                        </Box>
                                    }
                                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                        <Pagination color="primary" onChange={controller.handlePageChange} page={controller.currentPage} count={controller.countPagination} />
                                    </Box>
                                </Box>
                                :
                                <LinearProgress sx={{ mt: 2 }} />
                        }
                        <Popover
                            open={Boolean(controller.openMenu)}
                            anchorEl={controller.openMenu}
                            onClose={controller.handleCloseMenu}
                            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            PaperProps={{
                                sx: {
                                    p: 1,
                                    width: 140,
                                    '& .MuiMenuItem-root': {
                                        px: 1,
                                        typography: 'body2',
                                        borderRadius: 0.75,
                                    },
                                },
                            }}
                        >
                            <MenuItem onClick={controller.handleClickViewData}>
                                <InfoIcon />
                                &nbsp;&nbsp;
                                {t("View detail")}
                            </MenuItem>
                        </Popover>

                    </Box>
                    :

                    <OrderDetail onRefetchData={async () => {

                    }} selectedData={controller.selectedData} onClose={controller.handleCloseForm} />
            }
        </Box>


        {/* <LinearProgress sx={{ display: controller.loading ? "block" : "none" }} /> */}


    </Box>


}
export default SalesReportView;